module.exports = __webpack_public_path__ + "static/media/accounts.dbed5fd9.svg";